import { actionConst } from '../constants/invoice.constants';

const defaultState = {
	invoiceModalVisible: false,	
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.OPEN_INVOICE_MODAL: {
			console.log('--- OPEN_INVOICE_MODAL')
			console.log(action.payload)
			return {
				...state,
				request: action.payload.rid,
				invoiceModalVisible: true,
			}
		}

		case actionConst.CLOSE_INVOICE_MODAL: {
			return {
				...state,				
				invoiceModalVisible: false,
			}
		}
		default:
			return state;
	}
}